import React, { useEffect, useState } from "react";

import styles from "./ViewStudent.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../../../../axios";
import Loader from "../../../Loader";
import { ImageUrlPrefix } from "../../../../../labels";
import toast from "react-hot-toast";

function ViewStudent() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userIdView, eventIDView, ANSWERSHEETPATH, BATCHID } =
    location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const userJSON = sessionStorage.getItem("userDetails");
  let STAFFID = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.id) {
      STAFFID = user.id;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }
  const [testDetail, setTestDetail] = useState({
    tot_no_question: "",
    tot_marks: "",
    obtained_marks: "",
    obtained_marks_per: "",
    attend_status: "",
    attempt_no: "",
    handWriting: "",
    keyPoints: "",
    Presentation: "",
    Quality_of_content: "",
    Quantity_of_facts: "",
    Pictographics: "",
    headings: "",
    Subheadings: "",
    hightlight_facts: "",
    evaluated_answer_sheet: null,
    evaluated_answer_sheet_original: null,
    is_publish_result: null,
    event_name: "",
    answer_key_path: null,
    answer_key_original_path: null,
  });

  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/test/descriptive/stud_view", {
      event_id: eventIDView,
      user_id: userIdView,
      staff_id: STAFFID,
    })
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          const datavIEW = res.data.student_data;
          const datasa = {
            tot_no_question: datavIEW[0].no_of_questions,
            tot_marks: datavIEW[0].tot_marks,
            obtained_marks: datavIEW[0].marks_obtained,
            obtained_marks_per: datavIEW[0].marks_in_perc,
            attend_status: datavIEW[0].attendance_status,
            attempt_no: datavIEW[0].attempt_no,
            handWriting:
              datavIEW[0].hand_writing === 0
                ? String(datavIEW[0].hand_writing)
                : String(datavIEW[0].hand_writing),
            keyPoints: String(datavIEW[0].key_points),
            Presentation: String(datavIEW[0].presentation),
            Quality_of_content: String(datavIEW[0].quality_content),
            Quantity_of_facts: String(datavIEW[0].quantity_facts),
            Pictographics: String(datavIEW[0].pictographics),
            headings: String(datavIEW[0].headings),
            Subheadings: String(datavIEW[0].sub_heading),
            hightlight_facts: datavIEW[0].highlight_facts,
            evaluated_answer_sheet: datavIEW[0].descriptive_answer_sheet,
            evaluated_answer_sheet_original:
              datavIEW[0].descriptive_answer_sheet_original_path,
            is_publish_result: datavIEW[0].publish_results,
            event_name: datavIEW[0].name,
            answer_key_path: datavIEW[0].answer_key_path,
            answer_key_original_path: datavIEW[0].answer_key_original_path,
          };
          setTestDetail(datasa);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }, [userIdView]);

  const handleUpdateMarks = () => {
    navigate("/UpdateMarks", {
      state: {
        UMEVENTID: eventIDView,
        USERIDEM: userIdView,
        TOMARK: testDetail.tot_marks,
        ATTESTAT: testDetail.attend_status,
        ATTMPNO: testDetail.attempt_no,
        ATTENDSHEET_MARK: ANSWERSHEETPATH,
        BATCHID: BATCHID,
      },
    });
  };

  const handleDownloadAnswer = () => {
    if (ANSWERSHEETPATH) {
      window.open(`${ImageUrlPrefix}/${ANSWERSHEETPATH}`, "_blank");
    } else {
      toast.error("Data Not Found");
    }
  };
  const ratingOptions = [
    { value: "4", label: "Excellent" },
    { value: "3", label: "Good" },
    { value: "2", label: "Average" },
    { value: "1", label: "Below Average" },
    { value: "0", label: "Poor" },
  ];
  const getLabelForHandWriting = (handWriting) => {
    const rating = ratingOptions.find(
      (option) => option.value === String(handWriting)
    );
    return rating ? rating.label : "_";
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      <div className="viewStudent container-fluid global_container BathHeader">
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">View Student</h2>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  to="/StudentsList"
                  className="secondaryButton "
                  variant="secondary"
                >
                  Back to Students List
                </Link>
              </li>

              <li class="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  onClick={
                    testDetail.is_publish_result === 1
                      ? () => {}
                      : handleUpdateMarks
                  }
                  disbaled={testDetail.is_publish_result === 1 ? true : false}
                  className={`${
                    testDetail.is_publish_result === 1
                      ? "primaryButton disabled_btn "
                      : "primaryButton"
                  }`}
                  variant="primary"
                >
                  Update Marks
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  className="primaryButton"
                  variant="primary"
                  to={"javascript:void(0)"}
                  onClick={handleDownloadAnswer}
                >
                  <span className="material-icons me-1 align-middle text-white">
                    file_download
                  </span>
                  Download Answer Sheet
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* test details */}
        <div className="stuList">
          <fieldset className="mt-3">
            <legend className="w-auto">Test Details</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Test Name</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {testDetail.event_name ? testDetail.event_name : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="">
                  <label className="confirm_label m-0 p-0">Answer key </label>
                  {testDetail.answer_key_path !== null && (
                    <a
                      href={`${ImageUrlPrefix}/${testDetail.answer_key_path}`}
                      target="_blank"
                    >
                      <span
                        className={`${styles.mui_icon} material-icons   align-middle mx-1`}
                      >
                        file_download
                      </span>
                    </a>
                  )}

                  <p className="confirm_value my-1 m-0 p-0">
                    {testDetail.answer_key_original_path
                      ? testDetail.answer_key_original_path
                      : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">
                    Total Number of Questions
                  </p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {testDetail.tot_no_question
                      ? testDetail.tot_no_question
                      : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Total Marks</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {testDetail.tot_marks ? testDetail.tot_marks : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Obtained Marks</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {testDetail.obtained_marks ||
                    testDetail.obtained_marks === 0
                      ? testDetail.obtained_marks
                      : "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        {/* Comments */}
        <div className="stuList">
          <fieldset className="mt-3">
            <legend className="w-auto">Comments</legend>
            <div className="row">
              <div className="my-1 col-lg-3 col-md-3 col-12 mb-2">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Hand Writing</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {getLabelForHandWriting(testDetail.handWriting) || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12 mb-2">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Key Points</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {getLabelForHandWriting(testDetail.keyPoints) || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12 mb-2">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Presentation</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {getLabelForHandWriting(testDetail.Presentation) || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12 mb-2">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Quantity of Facts</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {getLabelForHandWriting(testDetail.Quantity_of_facts) ||
                      "_"}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="my-1 col-lg-3 col-md-3 col-12 mb-2">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Quality of Content</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {getLabelForHandWriting(testDetail.Quality_of_content) ||
                      "-"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12 mb-2">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Pictographics</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {getLabelForHandWriting(testDetail.Pictographics || "_")}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12 mb-2">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Headings</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {getLabelForHandWriting(testDetail.headings) || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12 mb-2">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Sub Headings</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {getLabelForHandWriting(testDetail.Subheadings) || "_"}
                  </p>
                </div>
              </div>
            </div>

            <div className="my-1 col-md-12 mb-2">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0">Final Comments</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {testDetail.hightlight_facts
                    ? testDetail.hightlight_facts
                    : "_"}
                </p>
              </div>
            </div>

            <div className="my-1 col-md-12 mb-3">
              <div className="">
                <label className="confirm_label m-0 p-0">
                  Evaluated Answer Sheet
                </label>
                {testDetail.evaluated_answer_sheet !== null && (
                  <a
                    href={`${ImageUrlPrefix}/${testDetail.evaluated_answer_sheet}`}
                    target="_blank"
                  >
                    <span
                      className={`${styles.mui_icon} material-icons   align-middle mx-1`}
                    >
                      file_download
                    </span>
                    <span
                      className={`${styles.mui_icon} material-icons    align-middle mx-1`}
                    >
                      visibility
                    </span>
                  </a>
                )}
                <p className="confirm_value my-1 m-0 p-0">
                  {/* {testDetail.evaluated_answer_sheet !== null
                    ? testDetail.evaluated_answer_sheet
                    : "_"} */}
                  {testDetail.evaluated_answer_sheet_original
                    ? testDetail.evaluated_answer_sheet_original
                    : "_"}{" "}
                </p>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </>
  );
}
export default ViewStudent;
